import React, { Component } from 'react';
import { PersianDatePicker } from '../elements/PersianDatePicker'
import { MyInput } from '../elements/MyInput'
import { Dropdown } from '../elements/Dropdown'
import p1 from '../images/p1.jpg';
import p2 from '../images/p2.jpg';
import p3 from '../images/p3.jpg';
import p4 from '../images/p4.jpg';
import p5 from '../images/p5.jpg';

export class Register extends Component {
    static displayName = Register.name;


    constructor(props) {
        super(props);
        this.state = {};
        this.state.data = {};
        this.state.data.mobileNo = this.props.match.params.id;
        this.cat = this.props.match.params.productcat;


        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getCity = this.getCity.bind(this);


        this.state.dataCities = [];
        this.state.dataProvinces = [];

        //this.state.data.province=4;

        this.headers =
        {
            'Content-Type': 'application/json'
        };

    }


    componentDidMount() {
        this.setState({ isLoading: true });
        fetch('api/v1/GetProvinces',
            {
                method: 'GET',
                headers: this.headers
            }).then(res => {
                this.status = res.status;

                res.json().then((result) => {
                    this.state.dataProvinces = result;
                    this.setState({ isLoading: false });
                    this.setState({});
                },
                    (error) => {
                        this.setState({ isLoading: false });
                    }
                );
            }
            );
    }


    handleTextChange(e, key) {

        if (key == "province") {

            if (e > 0) {
                this.getCity(e);
            }
            else {
                this.state.dataCities = [];
                this.setState({});
            }
        }

        //   console.log(e);
        this.state.data[key] = e;
        this.setState({});
    }


    getCity(provinceId) {

        //   this.setState({ isLoading: true });
        fetch('api/v1/GetCities?provinceId=' + provinceId,
            {
                method: 'GET',
                headers: this.headers
            }).then(res => {
                this.status = res.status;

                res.json().then((result) => {
                    this.state.dataCities = result;
                    this.setState({ isLoading: false });
                    this.setState({});
                },
                    (error) => {
                        this.setState({ isLoading: false });
                    }
                );
            }
            );
    }

    handleSubmit(e) {
        e.preventDefault();

        var data = this.state.data;
     //   console.log("api/v1/regs");

        this.setState({ isLoading: true });

        fetch('api/v1/regs',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: this.headers
            }).then(res => {
                this.status = res.status;

                res.json().then((result) => {

                    this.setState({ isLoading: false });
                    this.setState({});
                    if (res.status === 200) {
                        alert('ثبت با موفقیت انجام شد');
                    }
                    else {
                        alert(result.Value);
                        console.log(result);
                    }
                },
                    (error) => {
                        console.log(res);
                        alert(res.statusText);
                        this.setState({ isLoading: false });
                    }
                );
            }
            );


    }


    render() {

        if (this.state.isLoading) {
            return <div> ... </div>;
        }

        if (this.cat === null || this.cat === "" || this.cat === "undefined")
            this.cat = "1";


        var pic = p1;
        if (this.cat == "1")
            pic = p1;
        if (this.cat == "2")
            pic = p2;
        if (this.cat == "3")
            pic = p3;
        if (this.cat == "4")
            pic = p4;
        if (this.cat == "5")
            pic = p5;

        return (

            <div className="" style={{ height: "100%", width: "auto", backgroundRepeat: "no-repeat", backgroundSize: "100% auto", backgroundImage: `url(${pic})` }}>

                <div style={{ width: "100%" }}>


                    <div className="col-md-3 col-lg-4 " style={{ height: "auto" }}>

                    </div>
                    <div className="col-md-6 col-lg-4 col-sm-12 ">

                        <div style={{ height: "150px" }}>

                        </div>

                        <div style={{ width: "100%", padding: "10px", background: "white", opacity: "0.8", borderStyle: "solid", borderWidth: "2px", borderColor: "gray", borderRadius: "10px", direction: "rtl" }}>
                            <img src={require('../images/form.jpg')} style={{ width: '100%' }} />
                            <hr />

                            <form className="" onSubmit={this.handleSubmit} ref="myRef">
                                <MyInput onChange={this.handleTextChange} label="نام" name="name" ></MyInput>
                                <br />
                                <MyInput onChange={this.handleTextChange} label="نام خانوادگی" name="family" ></MyInput>
                                <br />
                                <Dropdown onChange={this.handleTextChange} Selected={this.state.data.province} Data={this.state.dataProvinces} label="استان" name="province" ></Dropdown>
                                <br />
                                <Dropdown onChange={this.handleTextChange} Data={this.state.dataCities} label="شهر" name="city" ></Dropdown>
                                <br />
                                <PersianDatePicker onChange={this.handleTextChange} label="تاریخ تولد" name="birthDate" />

                                <br />

                                <button className=" btn-primary btn-lg" style={{ float: "right", width: "100%" }} onClick={this.handleSubmit}>تایید </button>

                            </form>

                            <div className="row">

                                <div className="col-3">

                                </div>
                                <div className="col-6" style={{ height: '100px', textAlign: 'center' }}>
                                    <br />
                                    <br />
                                    <br />
                                    Powered By <a style={{ verticalAlign: 'middle', marginTop: '90px', top: '90px' }} href="http://allingroup.ir">  Allin Kish </a>
                                </div>

                            </div>


                        </div>

                    </div>


                    <div className="col-md-4" style={{ height: "200px" }}>

                    </div>

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Register.js